import { FileExcelOutlined } from '@ant-design/icons';
import { Button, notification } from 'antd';
import * as XLSX from 'xlsx';
import moment from 'moment';
import React, { ChangeEvent, FC, useRef } from 'react';
import { TOvertimeUser } from 'shared/types/overtime.types';
import { TUserRvdInfo } from 'shared/types/rvd.types';
import { WORK_TIME_OVER_MESSAGE_OVERTIME } from 'shared/constants/overtime';

type TProps = {
  onFinishExcell: (rvdUsers: TUserRvdInfo[] | TOvertimeUser[]) => void;
  parseExcell: (data: (string | number)[][]) => Promise<TUserRvdInfo[] | TOvertimeUser[]>;
};

export const excelToDate = (excellDate: number) => {
  const diffExcellAndJs = 25569;
  return moment((excellDate - diffExcellAndJs) * 24 * 3600 * 1000).toISOString();
};

export const calcTime = (days: number | string) => {
  let formattedTime: string;
  if (typeof days === 'number') {
    const totalHours = days * 24;
    const hours = Math.floor(totalHours);
    const minutes = Math.round((totalHours - hours) * 60);
    formattedTime = `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}`;
  } else {
    formattedTime = days;
  }
  return formattedTime;
};

const UploadExcell: FC<TProps> = ({ onFinishExcell, parseExcell }) => {
  const fileInput = useRef<HTMLInputElement | null>(null);
  const onExcelInputClick = () => {
    if (fileInput.current) {
      fileInput.current.click();
    }
  };

  const onExcellUpload = async (event: ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files ? event.target.files[0] : null;
    if (file) {
      const fileNameArray = file.name.split('.');
      if (!fileNameArray[fileNameArray.length - 1].toLowerCase().includes('xl')) {
        notification.error({ message: 'Недопустимое расширение файла' });
        return;
      }
      const data = await file.arrayBuffer();
      const workbook = XLSX.read(data);
      const worksheet = workbook.Sheets[workbook.SheetNames[0]];
      const jsonData = XLSX.utils.sheet_to_json(worksheet, {
        header: 1,
        defval: '',
      });
      const parsedData = await parseExcell(jsonData as (string | number)[][]);
      fileInput.current!.value = '';
      onFinishExcell(parsedData as TUserRvdInfo[]);
    }
  };

  return (
    <Button type="primary" onClick={onExcelInputClick}>
      <input type="file" style={{ display: 'none' }} ref={fileInput} onInput={onExcellUpload} />
      <FileExcelOutlined /> Загрузить Excel
    </Button>
  );
};

export default UploadExcell;
